//
//
//
//
//
//


export default {
  name: 'CardItem',
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/CardItem.vue